<template>
  <section class="AssignmentTestReports">
    <v-subheader class="text-h5">
      <span>Reports</span>
      <v-spacer />
      <v-chip v-if="reports.length" color="grey lighten-3">
        <span class="font-weight-bold">{{ reports.length }}</span>
      </v-chip>
    </v-subheader>
    <v-divider />

    <template v-if="reports.length">
      <AssignmentTestReport
        v-for="report in sortedReports"
        :key="report._id"
        :report="report"
        :assignment="assignment"
        :test-loading="testLoading"
        class="mt-4"
        @preview="previewReport(report)"
      />
    </template>
    <div
      v-else
      class="d-flex justify-center text-body-1 pa-6"
    >
      No reports
    </div>

    <AssignmentReportDialog
      v-if="openReportId"
      v-model="show.reportDialog"
      :assignment-id="assignment._id"
      :report-id="openReportId"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { sortBy } from 'lodash';

export default {
  name: 'AssignmentTestReports',
  components: {
    AssignmentTestReport: () => import('@/components/assignments/AssignmentTestReport'),
    AssignmentReportDialog: () => import('@/components/modals/assignments/AssignmentReportDialog'),
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: {
        reportDialog: false,
      },
      reports: [],
      openReportId: null,
    };
  },
  computed: {
    ...mapGetters('assignments', [
      'testsLoading',
    ]),
    sortedReports() {
      return sortBy(this.reports, 'startDate');
    },
    testLoading() {
      return this.testsLoading[this.assignment._id];
    },
  },
  created() {
    this.loadReports();
  },
  methods: {
    loadReports() {
      if (this.assignment.reports) {
        // TODO add lazy load for reports
        this.reports = this.assignment.reports;
      }
    },
    previewReport(report) {
      this.openReportId = report._id;
      this.show.reportDialog = true;
    },
  },
};
</script>
